import React from 'react';
export var InputLayoutContextDefault = {
  focused: false,
  disabled: false,
  size: 'small'
};
export var InputLayoutContext = /*#__PURE__*/React.createContext(InputLayoutContextDefault);